import { useQuery } from "@tanstack/react-query"
import { useGlobalState } from "../Components/GlobalStateProvider"
import { IRecord } from "../types/schema"
import { IBranchSettings } from "../utils/useSettings"

type IAddress = {
  id: string
  name: string
  line_1: string
  line_2: string
  line_3: string
  line_4: string
  city: string
  county: string
  country: string
  postcode: string
  phone: string
  email: string
}
const addressAttrs = [
  "name",
  "line_1",
  "line_2",
  "line_3",
  "line_4",
  "city",
  "county",
  "country",
  "postcode",
  "phone",
  "email",
]

export function useOrderRequestDefaultSettings() {
  const skeem = window.skeem
  const globalState = useGlobalState()

  const { isPending, error, data } = useQuery({
    queryKey: ["orderRequestDefaultSettings", globalState.currentUser.branch.id],
    queryFn: async () => {
      const branch = await skeem.fetch2<
        IRecord<"branches"> & {
          orderRequestBranches: (IRecord<
            "orderRequestBranches",
            "default" | "supplier" | "customer"
          > & {
            targetBranch: IRecord<"branches", "name"> & {
              settings: IBranchSettings
            }
            billingAddress: IAddress
            shippingAddress: IAddress
          })[]
        }
      >({
        first: {
          name: "branches",
          attributes: [
            {
              name: "orderRequestBranches",
              attributes: [
                {
                  name: "targetBranch",
                  attributes: ["name", "settings"],
                },
                "default",
                "supplier",
                "customer",
                { name: "billingAddress", attributes: addressAttrs },
                { name: "shippingAddress", attributes: addressAttrs },
              ],
            },
          ],
          filter: {
            matches: {
              id: globalState.currentUser.branch.id,
            },
          },
        },
      })

      const defaultOrBranch =
        branch.orderRequestBranches.filter(branch => branch.default)[0] ||
        branch.orderRequestBranches[0]

      console.log("defaultOrBranch", defaultOrBranch)
      return {
        id: defaultOrBranch?.targetBranch?.id,
        name: defaultOrBranch?.targetBranch?.name,
        supplierId: defaultOrBranch?.supplier?.id,
        customerId: defaultOrBranch?.customer?.id,
        billingAddress: defaultOrBranch?.billingAddress,
        shippingAddress: defaultOrBranch?.shippingAddress,
        settings: defaultOrBranch?.targetBranch?.settings,
      }
    },
  })
  return {
    isPending,
    error,
    data,
  }
}
